import React from 'react';
import { TableFilter } from 'components/UI/Table';
import { IBreach } from 'types/breach';
import { createSortableHeader, createSelectFilter, createTextFormatter, createBaseColumn } from './columnUtils';

/**
 * Создает универсальную колонку для менеджеров (РД, АО и т.д.)
 */
export const createManagerColumn = (
	config: {
		value: string;
		label: string;
		sortKey: string;
		filterKey: string;
		dataPath: (row: IBreach) => string | undefined;
	},
	filter: TableFilter,
	setFilter: (filter: TableFilter) => void,
	options: Array<{ value: string; label: string }>,
	sortTable: (key: string) => void,
	userWorkPlace?: string,
) => {
	const title = createSortableHeader(config.label, config.sortKey, filter, sortTable, { useShortLabel: true });

	const formatted = createTextFormatter(config.dataPath);

	const filterComponent = createSelectFilter(filter, setFilter, options, config.filterKey);

	return createBaseColumn(config.value, title, formatted, {
		width: '150px',
		filter: filterComponent,
		visible: userWorkPlace !== 'Розница',
	});
};

/**
 * Создает колонку для регионального директора
 */
export const createRegionalDirectorColumn = (
	filter: TableFilter,
	setFilter: (filter: TableFilter) => void,
	regionalManagersOptions: { label: string; value: string }[],
	sortTable: (key: string) => void,
	userWorkPlace?: string,
) => {
	return createManagerColumn(
		{
			value: 'regional-director',
			label: 'Закрепленный РД',
			sortKey: 'checkin.store.regional_manager',
			filterKey: 'regional_manager',
			dataPath: (row: IBreach) => row.checkin?.store?.regional_manager,
		},
		filter,
		setFilter,
		regionalManagersOptions,
		sortTable,
		userWorkPlace,
	);
};

/**
 * Создает колонку для АО менеджера
 */
export const createAoManagerColumn = (
	filter: TableFilter,
	setFilter: (filter: TableFilter) => void,
	aoManagersOptions: { label: string; value: string }[],
	sortTable: (key: string) => void,
	userWorkPlace?: string,
) => {
	return createManagerColumn(
		{
			value: 'administrative-department',
			label: 'Закрепленный АО',
			sortKey: 'checkin.store.ao_manager',
			filterKey: 'ao_manager',
			dataPath: (row: IBreach) => row.checkin?.store?.ao_manager,
		},
		filter,
		setFilter,
		aoManagersOptions,
		sortTable,
		userWorkPlace,
	);
};
